const languages = ['es', 'de'];

export const getLanguageFromPath = (url: string) => {
  return languages.filter((language) => url?.includes(`/${language}/`))[0];
};
